export const ersActionTypes = {
  ERS_DATA: "ERS_DATA"
};
